import type { ReactNode } from 'react'
import { KIND } from 'baseui/button'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'
import { ConfirmModalActions } from '../AdditionalSales/styled-components'
import useShellConfirmModal from './useShellConfirmModal'

interface ShellConfirmModalProps {
  isOpen: boolean
  title: string
  children: ReactNode
  cancelLabel: string
  confirmLabel: string
  onCancel: () => void
  onConfirm: () => void
  isLoading?: boolean
  confirmDisabled?: boolean
  closeable?: boolean
}

const ShellConfirmModal = ({
  isOpen,
  title,
  children,
  cancelLabel,
  confirmLabel,
  onCancel,
  onConfirm,
  isLoading = false,
  confirmDisabled = false,
  closeable = true,
}: ShellConfirmModalProps) => {
  const { close, modalOverrides } = useShellConfirmModal(closeable, onCancel)

  return (
    <SDModal
      isOpen={isOpen}
      openHandler={close}
      title={title}
      overrides={modalOverrides}
      sections={
        <>
          {children}
          <ConfirmModalActions>
            {/* @ts-expect-error SDButton is a JS component */}
            <SDButton kind={KIND.secondary} onClick={onCancel} disabled={!closeable}>
              {cancelLabel}
            </SDButton>
            {/* @ts-expect-error SDButton is a JS component */}
            <SDButton onClick={onConfirm} isLoading={isLoading} disabled={confirmDisabled}>
              {confirmLabel}
            </SDButton>
          </ConfirmModalActions>
        </>
      }
    />
  )
}

export default ShellConfirmModal
